import { HomeContainer } from "../containers/home";

export default function Home() {
  return <HomeContainer />;
}



